import React from "react";
import { Popup, ScrollView } from "devextreme-react";
import { NewConfig } from "..";

const NewApplication = ({ visible, onHide }) => {
  return (
    <Popup
      visible={visible}
      onHiding={onHide}
      title='Add New Configuration'
      showCloseButton
    >
      <ScrollView width='100%' height='100%'>
        <NewConfig isNewApp setIsNewApp={onHide} />
      </ScrollView>
    </Popup>
  );
};

export default NewApplication;
